import React, { useState, useEffect } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { Route, Routes } from 'react-router-dom';
import { Box, CssBaseline } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { getAuth, onAuthStateChanged } from './firebase.js' 

import NavToolbar from './pages/toolbar';
import Home from './pages/home';
import Contact from './pages/contact';
import Login from './pages/login'
import ResourceForm from './pages/resourceForm.js'
import AdminHotlines from './pages/adminhotline.js'
import ResourceTab from './pages/resourcetab';
import Footer from './pages/footer.js'
import HotlinePage from './pages/hotlinePage.js';

import ReadPageButton from "./components/ReadPageButton";


const theme = createTheme({
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          overflowX: 'hidden',
        },
      },
    },
  },
});

function App() {
  const [user, setUser] = useState(null);
  const [time, setTime] = useState(null);
  const [day, setDay] = useState("All");
  const [type, setType] = useState("Any");
  const [search, setSearch] = useState('');
  const helmetContext = {};
  
  useEffect(() => {
    const auth = getAuth();
    onAuthStateChanged(auth, (user) => {
      if (user) {
        setUser(user.uid);
      } else {
        setUser(null);
      }
    })
  }, [user]);
  return (
    <HelmetProvider context={helmetContext}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
          <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', width: '100vw', overflowX: 'hidden' }}>
            <Box sx={{height: "15vh"}}>
              <NavToolbar isAuthenticated={user ? true : false}/>
            </Box>
            <Box component="main" sx={{ flexGrow: 1, width: '100%' }}>
              <Routes>
                <Route path="/" element={<Home setType={setType} setTime={setTime} setDay={setDay}/>} />
                <Route path="/contact" element={<Contact />} />
                {user && <Route path="/resource-form" element={<ResourceForm/>}/>}
                {user && <Route path="/admin-hotlines" element={<AdminHotlines/>}/>}
                <Route path="/login" element={<Login isAuthenticated={user === null ? false : true}/>}/>
                <Route path="/hotlines" element={<HotlinePage/>} />
                <Route path="/resourcestab/*" element={<ResourceTab type={type} setType={setType} time={time} setTime={setTime} day={day} setDay={setDay} search={search} setSearch={setSearch}/>} />
              </Routes>
            </Box>

            <ReadPageButton />

            <Box>
              <Footer/>
            </Box>
          </Box>
      </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;
